import styled from '@mui/material/styles/styled';
import Toolbar from '@mui/material/Toolbar';

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  height: '100%',
  color: theme.palette.text.primary,
  background: theme.palette.background.paper,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  boxShadow: '0 1px 5px 0 rgba(127, 127, 227, 0.21)',
  zIndex: 1,
  overflowY: 'auto'
}));
